// extracted by mini-css-extract-plugin
module.exports = {"hide_modal":"BidModal_hide_modal__euh_4","modal":"BidModal_modal__pUL1r"};